export const name = "RecentlyViewed";

export const constants = { name };
